const local: App.I18n.Schema = {
  system: {
    title: 'Business Intelligence System'
  },
  common: {
    action: 'Action',
    add: 'Add',
    addSuccess: 'Add Success',
    backToHome: 'Back to home',
    batchDelete: 'Batch Delete',
    cancel: 'Cancel',
    close: 'Close',
    check: 'Check',
    expandColumn: 'Expand Column',
    columnSetting: 'Column Setting',
    config: 'Config',
    confirm: 'Confirm',
    view: 'view',
    delete: 'Delete',
    deleteSuccess: 'Delete Success',
    confirmDelete: 'Are you sure you want to delete?',
    edit: 'Edit',
    index: 'Index',
    keywordSearch: 'Please enter keyword',
    logout: 'Logout',
    logoutConfirm: 'Are you sure you want to log out?',
    lookForward: 'Coming soon',
    modify: 'Modify',
    fill: 'Fill in',
    set: 'Set',
    modifySuccess: 'Modify Success',
    noData: 'No Data',
    operate: 'Operate',
    pleaseCheckValue: 'Please check whether the value is valid',
    refresh: 'Refresh',
    reset: 'Reset',
    search: 'Search',
    switch: 'Switch',
    tip: 'Tip',
    trigger: 'Trigger',
    update: 'Update',
    updateSuccess: 'Update Success',
    userCenter: 'User Center',
    yesOrNo: {
      yes: 'Yes',
      no: 'No'
    }
  },
  request: {
    logout: 'Logout user after request failed',
    logoutMsg: 'User status is invalid, please log in again',
    logoutWithModal: 'Pop up modal after request failed and then log out user',
    logoutWithModalMsg: 'User status is invalid, please log in again',
    refreshToken: 'The requested token has expired, refresh the token',
    tokenExpired: 'The requested token has expired'
  },
  theme: {
    themeSchema: {
      title: 'Theme Schema',
      light: 'Light',
      dark: 'Dark',
      auto: 'Follow System'
    },
    grayscale: 'Grayscale',
    layoutMode: {
      title: 'Layout Mode',
      vertical: 'Vertical Menu Mode',
      horizontal: 'Horizontal Menu Mode',
      'vertical-mix': 'Vertical Mix Menu Mode',
      'horizontal-mix': 'Horizontal Mix menu Mode'
    },
    recommendColor: 'Apply Recommended Color Algorithm',
    recommendColorDesc: 'The recommended color algorithm refers to',
    themeColor: {
      title: 'Theme Color',
      primary: 'Primary',
      info: 'Info',
      success: 'Success',
      warning: 'Warning',
      error: 'Error',
      followPrimary: 'Follow Primary'
    },
    scrollMode: {
      title: 'Scroll Mode',
      wrapper: 'Wrapper',
      content: 'Content'
    },
    page: {
      animate: 'Page Animate',
      mode: {
        title: 'Page Animate Mode',
        fade: 'Fade',
        'fade-slide': 'Slide',
        'fade-bottom': 'Fade Zoom',
        'fade-scale': 'Fade Scale',
        'zoom-fade': 'Zoom Fade',
        'zoom-out': 'Zoom Out',
        none: 'None'
      }
    },
    fixedHeaderAndTab: 'Fixed Header And Tab',
    header: {
      height: 'Header Height',
      breadcrumb: {
        visible: 'Breadcrumb Visible',
        showIcon: 'Breadcrumb Icon Visible'
      }
    },
    tab: {
      visible: 'Tab Visible',
      cache: 'Tab Cache',
      height: 'Tab Height',
      mode: {
        title: 'Tab Mode',
        chrome: 'Chrome',
        button: 'Button'
      }
    },
    sider: {
      inverted: 'Dark Sider',
      width: 'Sider Width',
      collapsedWidth: 'Sider Collapsed Width',
      mixWidth: 'Mix Sider Width',
      mixCollapsedWidth: 'Mix Sider Collapse Width',
      mixChildMenuWidth: 'Mix Child Menu Width'
    },
    footer: {
      visible: 'Footer Visible',
      fixed: 'Fixed Footer',
      height: 'Footer Height',
      right: 'Right Footer'
    },
    themeDrawerTitle: 'Theme Configuration',
    pageFunTitle: 'Page Function',
    configOperation: {
      copyConfig: 'Copy Config',
      copySuccessMsg: 'Copy Success, Please replace the variable "themeSettings" in "src/theme/settings.ts"',
      resetConfig: 'Reset Config',
      resetSuccessMsg: 'Reset Success'
    }
  },
  route: {
    login: 'Login',
    403: 'No Permission',
    404: 'Page Not Found',
    500: 'Server Error',
    'iframe-page': 'Iframe',
    home: 'Home',
    'ad-serving-data': 'Ad Serving Statistics',
    'ad-serving-data_data': 'Ad Serving Data',
    'ad-serving-data_material-statistics': 'Ad Creative Statistics',
    'user-center': 'User Center',
    tools: 'Tools',
    function: 'System Function',
    function_tab: 'Tab',
    'function_multi-tab': 'Multi Tab',
    'function_hide-child': 'Hide Child',
    'function_hide-child_one': 'Hide Child',
    'function_hide-child_two': 'Two',
    'function_hide-child_three': 'Three',
    function_request: 'Request',
    'function_toggle-auth': 'Toggle Auth',
    'function_super-page': 'Super Admin Visible',
    manage: 'System Manage',
    manage_user: 'User Manage',
    'manage_user-detail': 'User Detail',
    manage_role: 'Role Manage',
    manage_menu: 'Menu Manage',
    apikey: 'MCP API Keys',
    'app-manage': 'Multi Menu',
    'statistics': 'statistics',
    'user-segment-query': 'User Segment',
    'user-segment-query_user-segment-label': 'Segment Tags',
    'user-segment-query_user-segment-analysis': 'Segment Data',
    'app-manage_app-store-detail': 'Application Detail',
    'statistics_app-event-mnage': 'App custom events',
    'app-manage_app-user': 'Application User',
    'app-manage_app-list': 'Application List',
    'app-manage_store-review': 'Store Reviews',
    'manage_logprocessmgr': 'Log Process Job Mgr',
    'statistics_cohort-analysis': "cohort analysis",
    'statistics_ad-event': "advertising event",
    'statistics_ab-test': "AB Test",
    'statistics_user-activity-query': "user activity query",
    'report-monitor': "report monitor",
    'statistics_report-download': "Custom Report",
    'statistics_game-level': "Level Statistics",
    'statistics_ad-detail': "Monetization Statistics",
    'statistics_churn-statistics': "Churn Statistics",
    'statistics_network-status-distribution': 'Network Status Distribution'
  },
  page: {
    abTest: {
      eventCount: 'Event Count',
      eventUsers: 'Users Completing the Event',
      eventCountPerDau: 'Events per Active User',
      summary: {
        title: 'Experiment Scale Assessment',
        description:
          'Shows whether each metric has reached the sample size required by the configured MDE; it does not indicate statistical significance or a winner.',
        noData: 'Run a query to view the experiment scale assessment',
        baseline: 'Baseline',
        selectBaseline: 'Select a baseline',
        experimentStartDate: 'Experiment start',
        elapsedDays: 'Elapsed days',
        formula: 'Estimation formula',
        mde: 'Minimum detectable effect (MDE)',
        cv: 'Coefficient of variation (CV)',
        requiredSampleSize: 'Target sample per variant',
        baselineValue: 'Baseline metric value',
        currentValue: 'Current metric value',
        differenceFromBaseline: 'Difference from baseline',
        averageDailySampleSize: 'Average daily sample',
        requiredDays: 'Estimated total days',
        sampleProgress: 'Sample progress',
        sampleReached: 'Sample target reached',
        cannotEstimate: 'Cannot estimate yet',
        moreDaysRequired: 'About {count} more days',
        dayValue: '{count} days',
        metrics: {
          newInstalls: 'New installs',
          dau: 'DAU',
          sessions: 'Sessions',
          revenue: 'Total revenue',
          arpDau: 'ARPDAU'
        }
      }
    },
    reportDownload: {
      queryResult: 'Query results ({count} rows)',
      downloadCsv: 'Download CSV',
      table: 'Table',
      lineChart: 'Line chart',
      barChart: 'Bar chart',
      displayMetric: 'Display metric',
      selectMetric: 'Select a metric',
      noChartMetric: 'No chartable metric is available in the current results',
      chartRequiresDay: 'Charts require the Day dimension',
      chartDimensionLimit: 'At most one dimension other than Day can be selected'
    },
    login: {
      common: {
        loginOrRegister: 'Login / Register',
        userNamePlaceholder: 'Please enter user name',
        emailPlaceholder: 'Please enter email',
        phonePlaceholder: 'Please enter phone number',
        codePlaceholder: 'Please enter verification code',
        passwordPlaceholder: 'Please enter password',
        confirmPasswordPlaceholder: 'Please enter password again',
        codeLogin: 'Verification code login',
        confirm: 'Confirm',
        back: 'Back',
        validateSuccess: 'Verification passed',
        loginSuccess: 'Login successfully',
        welcomeBack: 'Welcome back, {userName} !'
      },
      pwdLogin: {
        title: 'Password Login',
        rememberMe: 'Remember me',
        forgetPassword: 'Forget password?',
        register: 'Register',
        otherAccountLogin: 'Other Account Login',
        otherLoginMode: 'Other Login Mode',
        superAdmin: 'Super Admin',
        admin: 'Admin',
        user: 'User'
      },
      codeLogin: {
        title: 'Verification Code Login',
        getCode: 'Get verification code',
        reGetCode: 'Reacquire after {time}s',
        sendCodeSuccess: 'Verification code sent successfully',
        imageCodePlaceholder: 'Please enter image verification code'
      },
      register: {
        title: 'Register',
        agreement: 'I have read and agree to',
        protocol: '《User Agreement》',
        policy: '《Privacy Policy》'
      },
      resetPwd: {
        title: 'Reset Password',
        resetSuccess: 'Password has been reset. A notification email has been sent, please check your inbox'
      },
      bindWeChat: {
        title: 'Bind WeChat'
      }
    },
    about: {
      title: 'About',
      introduction: `BISystem is an elegant and powerful admin template, based on the latest front-end technology stack, including Vue3, Vite5, TypeScript, Pinia and UnoCSS. It has built-in rich theme configuration and components, strict code specifications, and an automated file routing system. In addition, it also uses the online mock data solution based on ApiFox. BISystem provides you with a one-stop admin solution, no additional configuration, and out of the box. It is also a best practice for learning cutting-edge technologies quickly.`,
      projectInfo: {
        title: 'Project Info',
        version: 'Version',
        latestBuildTime: 'Latest Build Time',
        githubLink: 'Github Link',
        previewLink: 'Preview Link'
      },
      prdDep: 'Production Dependency',
      devDep: 'Development Dependency'
    },
    home: {
      greeting: 'Good morning, {userName}, today is another day full of vitality!',
      projectCount: 'Project Count',
      todo: 'Todo',
      message: 'Message',
      installCount: 'Download Count',
      activity: 'activity',
      schedule: 'Work and rest Schedule',
      study: 'Study',
      work: 'Work',
      rest: 'Rest',
      entertainment: 'Entertainment',
      visitCount: 'Visit Count',
      turnover: 'Turnover',
      dealCount: 'Deal Count',
      creativity: 'Creativity',
      revenue: 'revenue',
      session: 'session',
      actual: 'actual',
      predict: 'predict',
      totalValue: 'total value',
      cpi: 'CPI',
      ltvOver90d: 'LTV of users from 3 months ago',
      ltvOver180d: 'LTV of users from 6 months ago',
      ltvPredictD180: 'Predicted LTV after 180 days'
    },
    function: {
      tab: {
        tabOperate: {
          title: 'Tab Operation',
          addTab: 'Add Tab',
          addTabDesc: 'To about page',
          closeTab: 'Close Tab',
          closeCurrentTab: 'Close Current Tab',
          closeAboutTab: 'Close "About" Tab',
          addMultiTab: 'Add Multi Tab',
          addMultiTabDesc1: 'To MultiTab page',
          addMultiTabDesc2: 'To MultiTab page(with query params)'
        },
        tabTitle: {
          title: 'Tab Title',
          changeTitle: 'Change Title',
          change: 'Change',
          resetTitle: 'Reset Title',
          reset: 'Reset'
        }
      },
      multiTab: {
        routeParam: 'Route Param',
        backTab: 'Back function_tab'
      },
      toggleAuth: {
        toggleAccount: 'Toggle Account',
        authHook: 'Auth Hook Function `hasAuth`',
        superAdminVisible: 'Super Admin Visible',
        adminVisible: 'Admin Visible',
        adminOrUserVisible: 'Admin and User Visible'
      },
      request: {
        repeatedErrorOccurOnce: 'Repeated Request Error Occurs Once',
        repeatedError: 'Repeated Request Error',
        repeatedErrorMsg1: 'Custom Request Error 1',
        repeatedErrorMsg2: 'Custom Request Error 2'
      }
    },
    apikey: {
      title: 'MCP API Keys',
      keyName: 'Name',
      keyId: 'Key ID',
      status: 'Status',
      statusMap: {
        active: 'Active',
        revoked: 'Revoked',
        expired: 'Expired'
      },
      createdAt: 'Created At',
      lastUsedAt: 'Last Used',
      expiresAt: 'Expires At',
      addKey: 'New Key',
      revoke: 'Revoke',
      confirmRevoke: 'Revoke this key? Agents using it stop working immediately.',
      revokeSuccess: 'Revoked',
      expiresIn: 'Expires In',
      expiresOption: {
        d30: '30 days',
        d90: '90 days',
        d180: '180 days',
        d365: '365 days',
        never: 'Never'
      },
      form: {
        keyName: 'Enter a name, e.g. Claude Desktop'
      },
      createTip: 'The key is shown only once at creation. If lost, revoke it and issue a new one.',
      issuedTitle: 'API Key Created',
      issuedTip: 'Copy it now. You will not be able to see it again after closing this dialog.',
      copy: 'Copy Key',
      copied: 'Copied',
      copySuccess: 'Copied to clipboard',
      copyUnsupported: 'Automatic copy is unavailable here, please select and copy manually',
      savedIt: 'I have saved it',
      usageTitle: 'How to use',
      usageEndpoint: 'MCP endpoint',
      usageHeader: 'Request header',
      usageScope: 'The key carries no extra privileges: it sees exactly the data you see when logged in.'
    },
    manage: {
      common: {
        status: {
          enable: 'Enable',
          disable: 'Disable'
        }
      },
      role: {
        title: 'Role List',
        roleName: 'Role Name',
        roleCode: 'Role Code',
        roleStatus: 'Role Status',
        roleDesc: 'Role Description',
        menuAuth: 'Menu Auth',
        appStatisticAuth: 'App Statistic Auth',
        form: {
          roleName: 'Please enter role name',
          roleCode: 'Please enter role code',
          roleStatus: 'Please select role status',
          roleDesc: 'Please enter role description'
        },
        addRole: 'Add Role',
        editRole: 'Edit Role'
      },
      user: {
        title: 'User List',
        userName: 'User Name',
        password: 'User Name',
        userGender: 'Gender',
        nickName: 'Nick Name',
        userPhone: 'Phone Number',
        userEmail: 'Email',
        userStatus: 'User Status',
        userRole: 'User Role',
        form: {
          userName: 'Please enter user name',
          password: 'Please enter password',
          userGender: 'Please select gender',
          nickName: 'Please enter nick name',
          userPhone: 'Please enter phone number',
          userEmail: 'Please enter email',
          userStatus: 'Please select user status',
          userRole: 'Please select user role'
        },
        addUser: 'Add User',
        editUser: 'Edit User',
        resetPassword: 'Reset Password',
        confirmResetPassword: 'Reset this user\'s password? The new password will be sent by email.',
        resetPasswordSuccess: 'Password reset successfully. An email has been sent to the user.',
        viewApp: 'View Application',
        gender: {
          undefine: 'undefine',
          male: 'Male',
          female: 'Female'
        }
      },
      menu: {
        home: 'Home',
        title: 'Menu List',
        id: 'ID',
        parentId: 'Parent ID',
        topLevelMenu: 'Top Level Menu',
        menuType: 'Menu Type',
        menuName: 'Menu Name',
        routeName: 'Route Name',
        routePath: 'Route Path',
        pathParam: 'Path Param',
        layout: 'Layout Component',
        page: 'Page Component',
        i18nKey: 'I18n Key',
        icon: 'Icon',
        localIcon: 'Local Icon',
        iconTypeTitle: 'Icon Type',
        order: 'Order',
        constant: 'Constant',
        keepAlive: 'Keep Alive',
        href: 'Href',
        hideInMenu: 'Hide In Menu',
        activeMenu: 'Active Menu',
        multiTab: 'Multi Tab',
        fixedIndexInTab: 'Fixed Index In Tab',
        query: 'Query Params',
        button: 'Button',
        buttonCode: 'Button Code',
        buttonDesc: 'Button Desc',
        menuStatus: 'Menu Status',
        statusNormal: 'Normal',
        statusDisabled: 'Disabled',
        visibleShow: 'Visible',
        visibleHidden: 'Hidden',
        menuPerms: 'Permission Code',
        menuDesc: 'Description',
        form: {
          home: 'Please select home',
          menuType: 'Please select menu type',
          menuName: 'Please enter menu name',
          parentId: 'Please select parent menu',
          menuPerms: 'Please enter permission code, e.g. auth::sys::menu',
          menuDesc: 'Please enter description',
          routeName: 'Please enter route name',
          routePath: 'Please enter route path',
          pathParam: 'Please enter path param',
          page: 'Please select page component',
          layout: 'Please select layout component',
          i18nKey: 'Please enter i18n key',
          icon: 'Please enter iconify name',
          localIcon: 'Please enter local icon name',
          order: 'Please enter order',
          keepAlive: 'Please select whether to cache route',
          href: 'Please enter href',
          hideInMenu: 'Please select whether to hide menu',
          activeMenu: 'Please select route name of the highlighted menu',
          multiTab: 'Please select whether to support multiple tabs',
          fixedInTab: 'Please select whether to fix in the tab',
          fixedIndexInTab: 'Please enter the index fixed in the tab',
          queryKey: 'Please enter route parameter Key',
          queryValue: 'Please enter route parameter Value',
          button: 'Please select whether it is a button',
          buttonCode: 'Please enter button code',
          buttonDesc: 'Please enter button description',
          menuStatus: 'Please select menu status'
        },
        addMenu: 'Add Menu',
        editMenu: 'Edit Menu',
        addChildMenu: 'Add Child Menu',
        type: {
          directory: 'Directory',
          menu: 'Menu'
        },
        iconType: {
          iconify: 'Iconify Icon',
          local: 'Local Icon'
        }
      }
    },
    userCenter: {
      account: 'Account',
      subscription: 'Notifications',
      subscriptionSettings: 'Subscription settings',
      subscriptionEnabled: 'Enabled',
      subscriptionDisabled: 'Disabled',
      subscribedApps: 'Subscribed apps',
      subscribedAppsEmpty: 'No apps selected',
      subscribedAppsCount: '{count} apps selected',
      selectSubscribedApps: 'Select apps to subscribe to',
      subscribedAppsHint: 'When enabled with no apps selected, all apps permitted for this account are subscribed',
      subscribedSources: 'Alert sources',
      selectSubscribedSources: 'Select alert types to subscribe to',
      selectAllSources: 'Select all',
      selectedSourcesCount: '{count} selected',
      sourceAdspend: 'Ad spend',
      sourceMetricsTrend: 'Metric trends',
      sourceRevenueReconcile: 'Revenue reconciliation',
      security: 'Security',
      integration: 'Integrations & preferences',
      dataAccess: 'Data access',
      visibleApps: 'Apps',
      visibleChannels: 'Channels',
      revenuePerm: 'Revenue',
      expensePerm: 'Cost',
      granted: 'Granted',
      notGranted: 'Not granted',
      all: 'All',
      unitApp: '{count} apps',
      unitChannel: '{count} channels',
      unset: 'Not set',
      noRole: 'No role assigned',
      tokenUnset: 'Not configured',
      dataSourcePref: 'Data source',
      siteDefault: 'Site default',
      adjustTokenTip: 'API token from your Adjust dashboard',
      save: 'Save'
    },
    muti_menu: {
      first: {
        appid: 'App id',
        revenueThreshold: 'Revenue Threshold'
      },
      appUser: {
        searchApp: 'Search App',
        channels: 'Channels',
        searchChannels: 'Search Channels',
        installDate: 'Install Date',
        userProfileFields: 'Profile Fields',
        selectAllFields: 'Select All',
        userId: 'User ID',
        exportAnomaly: 'Export Anomaly Data',
        exportVisibleCsv: 'Export CSV (Displayed Data)',
        exportCsv: 'Export CSV (Raw Data)',
        fields: {
          appid: 'App Id',
          ltv: 'LTV',
          device_id: 'Device ID',
          device_id_idfv: 'Device IDFV',
          adjust_id: 'Adjust ID',
          brand: 'Brand',
          model: 'Model',
          ram: 'RAM',
          screen_size: 'Screen Size',
          screen_dpi: 'Screen DPI',
          device_language: 'Device Language',
          device_country: 'Device Country',
          ip_country: 'IP Country',
          ip_city: 'IP City',
          install_time: 'Install Time',
          channel_source: 'Channel Source',
          campaign: 'Campaign',
          adgroup: 'Ad Group',
          creative: 'Creative',
          network_status: 'Network Status',
          is_emulator: 'Emulator',
          is_root: 'Rooted',
          last_active_time: 'Last Active Time',
          active_days: 'Active Days',
          current_login_streak: 'Current Login Streak'
        }
      },
      networkStatus: {
        reportVolume: 'Report Volume',
        causeBreakdown: 'Unreachable Cause Breakdown',
        causeBreakdownNote: 'Four unreachable categories returned by the summary API.',
        networkComposition: 'Network state composition',
        barRepresentsTotal: 'bar = 100%',
        noNetwork: 'No network',
        onlyCell: 'only cell',
        onlyWifi: 'only wifi',
        wifiAndCell: 'wifi&cell'
      },
      second: {
        applicationlist: 'application list',
        viewStore: 'View Store',
        applicationDetail: 'Application Detail',
        basicInfo: 'Basic Info',
        description: 'Description',
        media: 'Media',
        reviews: 'Reviews',
        versionRelease: 'Version Release',
        backApplicationList: 'Back to Application List',
        generateReplyList: 'Generate Reply List',
        generateReplyFailed: 'Generate Failed',
        generateReplyPartialFailed: '{count} replies failed to generate',
        selectAllReviews: 'Select All Reviews',
        selectAllReplies: 'Select All Replies',
        sendAllReplies: 'Send Selected Replies',
        monitorCountry: 'Monitor Region',
        receiveAlarm: 'Receive Alerts',
        confirmUpdateApplicationDetail: 'Update {label} to {value}?',
        confirmReceiveAlarm: 'Receive alerts?',
        confirmIgnoreAlarm: 'Stop receiving alerts?',
        storeReview: {
          overview: 'Overview',
          searchApp: 'Search App',
          packageName: 'Package Name',
          appName: 'App Name',
          author: 'Author',
          rating: 'Rating',
          rate: 'Rate',
          min: 'Min',
          max: 'Max',
          reviewReplyStatus: 'Reply Status',
          replied: 'Replied',
          aiSuggestedReply: 'AI Suggested Reply',
          aiSuggestedNoReply: 'AI Suggested No Reply',
          aiReplyNotGenerated: 'AI Reply Not Generated',
          preparedReply: 'AI Reply Generated',
          reviewTime: 'Review Time',
          review: 'Review',
          reply: 'Reply',
          developer: 'Developer',
          developerReply: 'Published Reply',
          pendingReply: 'Pending Reply',
          aiGeneratedReply: 'AI Generated Reply',
          sendThisReply: 'Send This Reply',
          resendThisReply: 'Resend',
          replyTime: 'Reply Time',
          aiNoReplySuggestion: 'AI suggests no reply',
          preparedReplyFailed: 'AI Reply Generation Failed',
          appVersion: 'App Version',
          appVersionPlaceholder: 'Select version'
        },
        sendResult: 'Send Result'
      },
      logprocessmgr: {
        title: 'Log Process Job Manager',
        status: 'Current Status',
        begintime: 'Begin From',
        processedfiles: 'File Processed This Time',
        nexttime: 'Next Job Starting At',
        manualstart: 'Manual Start Processing',
        refresh: 'Refresh',
        processspeed: 'Speed of Processing'
      }
    },
    cohort: {
      common: {
        cohortAnalysis: 'cohort analysis'
      }
    }
  },
  form: {
    required: 'Cannot be empty',
    userName: {
      required: 'Please enter user name',
      invalid: 'User name format is incorrect'
    },
    phone: {
      required: 'Please enter phone number',
      invalid: 'Phone number format is incorrect'
    },
    pwd: {
      required: 'Please enter password',
      invalid: '6-18 characters, including letters, numbers, and underscores'
    },
    confirmPwd: {
      required: 'Please enter password again',
      invalid: 'The two passwords are inconsistent'
    },
    code: {
      required: 'Please enter verification code',
      invalid: 'Verification code format is incorrect'
    },
    email: {
      required: 'Please enter email',
      invalid: 'Email format is incorrect'
    }
  },
  dropdown: {
    closeCurrent: 'Close Current',
    closeOther: 'Close Other',
    closeLeft: 'Close Left',
    closeRight: 'Close Right',
    closeAll: 'Close All'
  },
  icon: {
    themeConfig: 'Theme Configuration',
    themeSchema: 'Theme Schema',
    lang: 'Switch Language',
    fullscreen: 'Fullscreen',
    fullscreenExit: 'Exit Fullscreen',
    reload: 'Reload Page',
    collapse: 'Collapse Menu',
    expand: 'Expand Menu',
    pin: 'Pin',
    unpin: 'Unpin'
  },
  datatable: {
    itemCount: 'Total {total} items'
  }
};

export default local;
